export type TMedicalReview = {
    reviewer?: {
        name?: string;
    };
    lastReviewed?: string;
};

type TProps = {
    canonicalUrl: string;
    description: string;
    medicalReview?: TMedicalReview;
    title: string;
};

export type TMedicalReviewStructuredData = {
    '@context': 'https://schema.org';
    '@type': 'WebPage';
    url: string;
    name: string;
    description: string;
    reviewedBy: {
        '@type': 'Person';
        name: string;
    };
    lastReviewed: string;
};

const isDate = (value?: string): value is string => /^\d{4}-\d{2}-\d{2}$/.test(value ?? '');

export const getMedicalReviewStructuredData = ({
    canonicalUrl,
    description,
    medicalReview,
    title
}: TProps): TMedicalReviewStructuredData | undefined => {
    const reviewerName = medicalReview?.reviewer?.name?.trim();

    if (!reviewerName || !isDate(medicalReview?.lastReviewed)) return undefined;

    return {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        url: canonicalUrl,
        name: title,
        description,
        reviewedBy: {
            '@type': 'Person',
            name: reviewerName
        },
        lastReviewed: medicalReview.lastReviewed
    };
};

export const serializeStructuredData = (data: TMedicalReviewStructuredData): string =>
    JSON.stringify(data).replace(/</g, '\\u003c');
